<script setup lang="ts">
  import { onMounted, ref } from 'vue'
  import { useSessionBootstrap } from './session-bootstrap'
  import AppSplashScreen from './components/AppSplashScreen.vue'

  // The composables that `useSessionBootstrap` itself calls (router, route,
  // user, signalR, etc.) bind to this component's setup phase here.
  // `provideContexts()` is the first synchronous statement inside
  // `initializeApp()`; calling it from `onMounted`'s sync prefix preserves
  // today's `getCurrentInstance()` timing (cluster-promotion plan §3 row 0).
  const { initializeApp } = useSessionBootstrap()

  const appReady = ref(false)

  onMounted(async () => {
    await initializeApp()
    appReady.value = true
  })

  defineExpose({
    initializeApp
  })
</script>
<template>
  <slot v-if="appReady" />
  <AppSplashScreen v-else />
</template>
